const columns = {
  AssetGroup: _TL_('Asset group'),
  Status: _TL_('Status'),
  DeliveryStatus: _TL_('Delivery'),
  Assets: _TL_('Assets'),
  AudienceSignal: _TL_('Audience signal'),
};

const columnChooser = {
  ColumnChooser_Header: _TL_('Modify columns'),
  ColumnChooser_SubHeader: _TL_(''),
  ColumnChooser_AvailableColumnsHeader: _TL_('Available columns'),
  ColumnChooser_SelectedColumnsHeader: _TL_('Selected columns (drag and drop to reorder)'),
  ColumnChooser_SelectedColumnsHeader_TopHalf: _TL_('Selected rows'),
  ColumnChooser_SelectedColumnsHeader_BottomHalf: _TL_('Selected columns'),
  ColumnChooser_SaveColumnDescription: _TL_('Save this set of columns'),
  ColumnChooser_Apply: _TL_('Apply'),
  ColumnChooser_Cancel: _TL_('Cancel'),
  ColumnChooser_Add: _TL_('Add'),
  ColumnChooser_Added: _TL_('Added'),
  ColumnChooser_Remove: _TL_('Remove'),
  ColumnChooser_AddAllInList: _TL_('Add all columns'),
  ColumnChooser_RemoveAllInList: _TL_('Remove all columns'),
  ColumnChooser_RemoveAllSelected: _TL_('Remove all selected columns'),
  ColumnChooser_NoSearchResult: _TL_('No results found'),
  ColumnChooser_Disabled: _TL_('Add'),
  ColumnChooser_Search_Column: _TL_('Search column'),
  ColumnChooser_AddColumn: _TL_('Add Column {{columnName}}'),
  ColumnChooser_RemoveColumn: _TL_('Remove Column {{columnName}}'),
  ColumnChooser_LiftColumn: _TL_('You have lifted the {{columnName}} column in position {{positionFrom}}.'),
  ColumnChooser_MoveColumn: _TL_('You have moved the {{columnName}} column from position {{positionFrom}} to position {{positionTo}}.'),
  ColumnChooser_DropColumn: _TL_('You have dropped the {{columnName}} column. You have moved the {{columnName}} column from position {{positionFrom}} to position {{positionTo}}.'),
  ColumnChooser_RemovedColumns: _TL_('You have removed the {{columnNames}} columns.'),
  ColumnChooser_RemovedColumn: _TL_('You have removed the {{columnNames}} column.'),
  ColumnChooser_AddedColumns: _TL_('You have added the {{columnNames}} columns.'),
  ColumnChooser_AddedColumn: _TL_('You have added the {{columnNames}} column.'),
};

export const assetGroupSchema = {
  Schema_AssetGroup_Property_Name: _TL_('Asset group name'),
  Schema_AssetGroup_Property_Status: _TL_('Status'),
  Schema_AssetGroup_Property_DeliveryStatus: _TL_('Delivery'),
  Schema_PerformanceMetrics_Property_Impressions: _TL_('Impr.'),
  Schema_PerformanceMetrics_Property_Clicks: _TL_('Clicks'),
  Schema_PerformanceMetrics_Property_CTR: _TL_('CTR'),
  Schema_PerformanceMetrics_Property_ConversionsCredit: _TL_('Conv.'),
  Schema_PerformanceMetrics_Property_Spend: _TL_('Spend'),
  Schema_PerformanceMetrics_Property_AverageCPC: _TL_('Avg. CPC'),
  Schema_PerformanceMetrics_Property_AdvertiserReportedRevenue: _TL_('Revenue'),
  Schema_PerformanceMetrics_Property_RevenueOnAdSpend: _TL_('Return on ad spend'),
  Schema_PerformanceMetrics_Property_AverageCPS: _TL_('Avg. CPS'),
  Schema_PerformanceMetrics_Property_SalesCount: _TL_('Sales Count'),
  Schema_PerformanceMetrics_Property_Downloads: _TL_('Downloads'),
  Schema_PerformanceMetrics_Property_FirstLaunches: _TL_('First Launches'),
  Schema_PerformanceMetrics_Property_Purchases: _TL_('Purchases'),
  Schema_PerformanceMetrics_Property_CostPerFirstLaunch: _TL_('Cost per first launch'),
  Schema_PerformanceMetrics_Property_CostPerDownload: _TL_('Cost per download'),
  Schema_PerformanceMetrics_Property_CostPerSubscription: _TL_('Cost per subscription'),
  Schema_PerformanceMetrics_Property_PostClickFirstLaunchRate: _TL_('Post-click first launch rate'),
  Schema_PerformanceMetrics_Property_PostClickDownloadRate: _TL_('Post-click download rate'),
  Schema_PerformanceMetrics_Property_PostInstallSubscriptionRate: _TL_('Post-install subscription rate'),
  Schema_PerformanceMetrics_Property_PostInstallPurchaseRate: _TL_('Post-install purchase rate'),
  Schema_PerformanceMetrics_Property_CostPerPurchase: _TL_('Cost per purchase'),
  AssetGroupStatus_Active: _TL_('Enabled'),
  AssetGroupStatus_Paused: _TL_('Paused'),
  AssetGroupStatus_Deleted: _TL_('Deleted'),
  AssetGroupStatus_Expired: _TL_('Expired'),
  Label_DeliveryStatus_Eligible: _TL_('Eligible'),
  Label_DeliveryStatus_AssetGroupUserPaused: _TL_('Asset group paused'),
  Label_DeliveryStatus_CampaignUserPaused: _TL_('Campaign paused'),
  Label_DeliveryStatus_CampaignBudgetPaused: _TL_('Campaign out of budget'),
  Label_DeliveryStatus_CampaignSuspended: _TL_('Campaign suspended'),
  Label_DeliveryStatus_CampaignInProgress: _TL_('Campaign incomplete'),
  Label_DeliveryStatus_ShoppingCampaignStoreNotFound: _TL_('Store not found'),
  Label_DeliveryStatus_ShoppingCampaignNoOffersPresent: _TL_('Product offers not found'),
  Label_DeliveryStatus_InvalidFinancialStatusOther: _TL_('Hold'),
  Label_DeliveryStatus_EditorialApprovedLimited: _TL_('Approved limited'),
  Label_DeliveryStatus_EditorialRejected: _TL_('Disapproved'),
  Label_DeliveryStatus_EditorialApprovedLimitedAppealRejected: _TL_('Approved limited, exception denied'),
  Label_DeliveryStatus_EditorialAppealRejected: _TL_('Disapproved, exception denied'),
  Label_DeliveryStatus_EditorialUnderAppeal: _TL_('Exception under review'),
  Label_DeliveryStatus_EditorialPending: _TL_('Pending editorial review'),
};

export const validations = {
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_Number_Require_Numeric: _TL_('Field requires numeric value'),
  Validation_Number_Max_Length: _TL_('Number should not exceed max length'),
  Validation_Number_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_Number_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  Validation_Array_Size_Max: _TL_('List should have at most {{max}} items'),
  Validation_Array_Size_Between: _TL_('List should have at least {{min}} and at most {{max}} items'),
  Validation_Array_Items_Invalid: _TL_('Some of items in list are invalid'),
  Validation_Array_Items_Duplicate: _TL_('List has duplicate items'),
};

export const appeals = {
  Editorial_RejectionDetail_Default: _TL_('Policy Violation: Your ad or website contains content that is not allowed on Microsoft Advertising.'),
  EditorialAppeal_AdsItem1: _TL_('You can edit this ad OR'),
  EditorialAppeal_AdsItem2: _TL_('You can request an exception'),
  EditorialAppeal_AdsSummaryText: _TL_('This ad does not meet our editorial guidelines'),
  EditorialAppeal_AllEntitiesInThisAdGroup_Capitalized: _TL_('All {0} in this ad group'),
  EditorialAppeal_AllEntitiesInThisAdGroup: _TL_('all {0} in this ad group'),
  EditorialAppeal_AllEntitiesInThisCampaign: _TL_('all {0} in this campaign'),
  EditorialAppeal_AppealTitle: _TL_('Request an exception (Your ad will be saved and reviewed by Microsoft Advertising)'),
  EditorialAppeal_Entity_Ad_Plural: _TL_('ads'),
  EditorialAppeal_Entity_Ad_SingularOrPlural: _TL_('ad(s)'),
  EditorialAppeal_Entity_Ad: _TL_('ad'),
  EditorialAppeal_Entity_Keyword_Plural: _TL_('keywords'),
  EditorialAppeal_Entity_Keyword_SingularOrPlural: _TL_('keyword(s)'),
  EditorialAppeal_Entity_Keyword: _TL_('keyword'),
  EditorialAppeal_Entity_Assetgroup: _TL_('asset group'),
  EditorialAppeal_Entity_Assetgroup_Plural: _TL_('asset groups'),
  EditorialAppeal_Justification: _TL_('Tell us your reason for requesting an exception:'),
  EditorialAppeal_JustificationRequired: _TL_('Enter your reason for requesting an exception.'),
  EditorialAppeal_JustificationTextRequired: _TL_('Enter your reason for requesting an exception.'),
  EditorialAppeal_KeywordMenu: _TL_('Request an exception'),
  EditorialAppeal_RejectedTerms: _TL_('Disapproved terms:'),
  EditorialAppeal_RejectionReasons: _TL_('Disapproved reason:'),
  EditorialAppeal_RequestAnException: _TL_('request an exception'),
  EditorialAppeal_RequestAnExceptionForEntityOrAllEntityInAdGroup: _TL_('request an exception for {0} or for {1}'),
  EditorialAppeal_SelectedEntityOrEntities: _TL_('Selected {0}'),
  EditorialAppeal_ThisEntity: _TL_('this {0}'),
  EditorialFlagsDialog_Title: _TL_('Disapproved reasons'),
  EditorialNotAppealableMessage: _TL_('We’ve already reviewed the terms in the Disapproved terms list and they aren’t eligible for you to request an exception. If you don’t see any Disapproved terms, check back later to see if you can request an exception.'),
  Fix_Disapproved_Entity_Help: _TL_('How to fix a disapproved {0}'),
};

export const legacyI18nKeys = [
  columns,
  columnChooser,
  assetGroupSchema,
  validations,
  appeals,
];
